var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChats = function SvgChats(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 18,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.333,
    d: "M16.375 5.25v6c0 1.275-.975 2.25-2.25 2.25h-2.25l-2.25 2.25-2.25-2.25h-2.25c-1.275 0-2.25-.975-2.25-2.25v-6c0-1.275.975-2.25 2.25-2.25h9c1.275 0 2.25.975 2.25 2.25m-10.5 1.5h4.5m-4.5 3h7.5"
  })));
};
export default SvgChats;